module.exports = __webpack_public_path__ + "static/media/icon Language - pink E4B2B2.beb408c7.svg";